import { configureStore } from '@reduxjs/toolkit';

import authToken from './authTokenSlice';
import country from './countrySlice';
import booking from './bookingSlice';
import favorite from './favoriteSlice';
import i18n from './i18nSlice';
import ipdata from './ipdataSlice';
import matchMedia from './matchMediaSlice';
import resyConfig from './resyConfigSlice';
import blog from './blogSlice';
import amexGDAEvents from './amexEventsSlice';
import amexDeltaWifi from './amexDeltaWifiSlice';
import venueInventory from './venueInventorySlice';
import collections from './collectionsSlice';
import venueReservations from './venueReservationsSlice';
import venueSearch from './venueSearchSlice';
import resyLocations from './resyLocationsSlice';
import resyCore from './resyCoreSlice';
import user from './userSlice';
import favoriteVenues from './favoriteVenuesSlice';
import resyRouter from './resyRouterSlice';
import signal from './signalSlice';
import naaAnnouncement from './announcementsSlice';
import experiments from './experimentsSlice';
import tockInterstitial from './tockInterstitialSlice';
import tockExperience from './tockExperienceSlice';
import amexAds from './amexAdsSlice';
import inviteRsvp from './inviteRsvpSlice';

import listenerMiddleware from './listenerMiddleware';

const store = configureStore({
  reducer: {
    i18n,
    signal,
    resyRouter,
    authToken,
    user,
    resyCore,
    blog,
    collections,
    country,
    booking,
    experiments,
    favorite,
    favoriteVenues,
    ipdata,
    matchMedia,
    resyConfig,
    amexGDAEvents,
    venueInventory,
    venueReservations,
    venueSearch,
    amexDeltaWifi,
    resyLocations,
    naaAnnouncement,
    tockInterstitial,
    tockExperience,
    amexAds,
    inviteRsvp,
  },
  devTools: ENV !== 'prod',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action types
      ignoredActions: [],
      // Ignore these field paths in all actions
      ignoredActionPaths: [
        'payload.config.adapter',
        'payload.config.transformRequest',
        'payload.config.transformResponse',
        'payload.config.validateStatus',
        'payload.request',
        'meta.arg.selectedDate',
        'meta.arg.userLogout',
      ],
      // Ignore these paths in the state
      ignoredPaths: [],
    },
  }).prepend(listenerMiddleware.middleware),
});

export default store;
